import { Component } from '@angular/core';
import { LoginService } from '../login/login.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedModule} from "../../app/shared/shared.module";
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../header/header.component';


@Component({
    selector: 'app-bi-report',
    imports: [
        CommonModule,
        SharedModule,
        HeaderComponent
    ],
    templateUrl: './bi-report.component.html',
    styleUrls: ['./bi-report.component.css']
})
export class BiReportComponent {
  BIReportUrl:any;
  constructor(protected _sanitizer: DomSanitizer){

  }

  ngOnInit(){
    this.BIReportUrl = this._sanitizer.bypassSecurityTrustResourceUrl(localStorage.getItem('biReportURL'));
  }

}
